import { BaseApiClient } from './base'
import type { UserMembership, MembershipTierConfig, MembershipLimits } from '../../types'

export class MembershipApi extends BaseApiClient {
  async getMembership(): Promise<{ success: boolean; membership: UserMembership }> {
    return this.request('/membership')
  }

  async getMembershipTiers(): Promise<{ success: boolean; tiers: MembershipTierConfig[] }> {
    return this.request('/membership/tiers')
  }

  async upgradeMembership(tier: string): Promise<{ 
    success: boolean; 
    membership?: UserMembership; 
    message?: string;
    subscription_id?: string;
    client_secret?: string;
    status?: string;
    error?: string;
  }> {
    return this.request('/membership/upgrade', {
      method: 'POST',
      body: JSON.stringify({ tier }),
    })
  }

  async getMembershipLimits(): Promise<{ success: boolean; limits: MembershipLimits }> {
    return this.request('/membership/limits')
  }

  async getUpgradeStatus(expectedTier: string): Promise<{
    status: 'pending' | 'completed' | 'failed';
    current_tier: string;
    tier_name?: string;
    subscription_status?: string;
  }> {
    return this.request(`/membership/upgrade/status?expected_tier=${expectedTier}`)
  }
}

